<app-header></app-header>

<section id="quienes-somos-blq1" class="bg-grey reset-section-pad" *ngIf="isDataLoaded">

    <div class="container">

          <div class="row">
            <app-title-section
                [titleTxt]="quienesSomosData.titleTxt"
            ></app-title-section>
         </div>


         <div class="row">
             <div class="col-lg-12 mx-auto">
                <app-one-col-carousel
                    [oneColCarousel_items]="quienesSomosData.oneColCarousel_items"
                ></app-one-col-carousel>
             </div>   
         </div>
     </div>

</section>

<section id="quienes-somos-blq2" class="bg-dark reset-section-mar-neg" *ngIf="isDataLoaded">

    <div class="container">

        <app-block-area-quienes
            [blockAreaQuienes_items]="quienesSomosData.blockAreaQuienes_items"
        ></app-block-area-quienes>

     </div>

</section>

<section id="quienes-somos-blq3" class="bg-grey section-fluid" *ngIf="isDataLoaded">

    <div class="container-fluid">

          <div class="row">

          	<div class="col-lg-12 quienes-somos-blq3-inner mb-md-flex-dir-col">
                <div class="col-lg-6 col-md-6 col-sm-12 col-12 quienes-somos-blq3-inner2">      
                    <app-img-title
                        [imgTitle_params]="quienesSomosData.imgTitle_params"
                    ></app-img-title>
          		</div>

          		<div class="col-lg-6 col-md-6 col-sm-12 col-12 quienes-somos-blq3-inner">
                    <div id="carousel4" class="carousel slide carousel-fade carouselTipo2" data-bs-ride="carousel">
                        <app-one-col-carousel-text
                            [oneColCarouselText_items]="quienesSomosData.oneColCarouselText_items"
                        ></app-one-col-carousel-text>
                    </div><!-- fin carousel-->
          		</div>	

          	</div>	
           
         </div>


     </div>
</section>

<section id="quienes-somos-blq4 px-0 py-0" class="bg-grey" *ngIf="isDataLoaded">

    <div class="container">
        <app-phrases-quienes
            [phrasesQuienesSomos_items]="quienesSomosData.phrasesQuienesSomos_items"
        ></app-phrases-quienes>
     </div>

</section>

<section id="quienes-somos-blq5" class="bg-light" *ngIf="isDataLoaded"
[style.background-image]="backgroundImageUrl"
>
    <div class="container">
        <app-parallax-quienes
            [ParallaxQuienesSomos_props]="quienesSomosData.ParallaxQuienesSomos_props"
        ></app-parallax-quienes>
    </div>

</section>

<section id="quienes-somos-blq6" *ngIf="isDataLoaded">

    <div class="container">

          <div class="row">
              <app-two-col-area-no-button
                [twoColAreaNoButtonItems]="quienesSomosData.twoColAreaNoButtonParams">
            </app-two-col-area-no-button>
            
                  
             </div>   
         </div>

</section>

<app-footer-main></app-footer-main>